// 会員情報登録エラー時に表示するメッセージを一元管理するためのファイル
// メッセージは一意なエラーコードにつきひとつ紐づく

/**
 * エラーコードに紐づくエラーメッセージを返す。
 * メッセージが見つからなかった場合、文字列の「not found」を返す。
 * @param code エラーコード
 */
export const getErrorMessage = (code: string): string => {
  if (errorMap.has(code)) {
    return errorMap.get(code)
  } else {
    return 'not found'
  }
}

/**
 * メッセージ管理オブジェクト
 * 1：不正アクセス
 * 2：期限切れ
 * 3：処理済み
 */
const errorMap = new Map()
// 403: message forbidden
errorMap.set('403', '予想外のエラーが発生しました。')
// 404: message notfound
errorMap.set('404', '予想外のエラーが発生しました。')
// transition.incorrect.url: 遷移エラー
errorMap.set('transition.incorrect.url', 'URLパラメータが正しくないため、処理できません。')
// zip.incorrect.input.char: 住所検索文字数エラー
errorMap.set('zip.incorrect.input.char', '郵便番号は半角数字7桁とハイフンの組み合わせで入力してください')
// pwr: パスワード再設定
errorMap.set('pwr1', 'パスワード再設定メールに記載されたURLにアクセスしてください。')
errorMap.set('pwr2', 'パスワードは既に変更されています。')
errorMap.set('pwr3', 'URLの有効期限が切れています。 パスワード再設定の手続きを再度行ってください。')
// emr: メールアドレス変更
errorMap.set('emr1', 'メールアドレス変更メールに記載されたURLにアクセスしてください。')
errorMap.set('emr2', 'メールアドレスは既に変更されています。')
errorMap.set('emr3', 'URLの有効期限が切れています。メールアドレス変更の手続きを再度行ってください。')
// pwr: 先行登録パスワード設定
errorMap.set('pre1', 'パスワード設定メールに記載されたURLにアクセスしてください。')
errorMap.set('pre2', 'パスワードは既に設定されています。')
errorMap.set('pre3', 'URLの有効期限が切れています。')
